import { GetFormatTitle } from "../Components/tableComponent/getTableColumn/getFormattedData";
import { fieldsToExcludeFromDetails } from "../constants/InsightPageColumnsInfo";
import { ApplicationDisplayItem } from "../Models/applicationModels";
import { AGENT_NAME, APPLICATION_DETAILS_AMOUNT_KEYS, APPLICATION_DETAILS_DATE_KEYS, APPLICATION_DETAILS_KEY_TO_CATEGORY, APPLICATION_DETAILS_LABEL_MAP, APPLICATION_DETAILS_ORDERED_KEYS, PIVOT_TARGET_TO, PIVOT_SOURCE_FROM, APPLICATION_DETAILS_DATE_ONLY_KEYS,} from "./constants/applicationDetailsBifurcation";
import { formatUTCDate, formatUTCDateTime } from "./formatUTCDate";
import { capitalizeFirstLetter, formatCurrency } from "./stringUtils";

const EXCLUDED_KEYS = new Set([...fieldsToExcludeFromDetails, "userFirstName", "userLastName"]);
const PIVOT_TIME_STAMP_AVAILABLE_KEYS = new Set([PIVOT_SOURCE_FROM, PIVOT_TARGET_TO]);

const getCombinedFieldValue = (key: string, applicationDetails: Record<string, any>) => {
    if (key === AGENT_NAME) {
        return [applicationDetails.userFirstName, applicationDetails.userLastName].filter(Boolean).join(" ").trim() || undefined;
    }
};

const formatValues = (key: string, value: any) => {
    if (APPLICATION_DETAILS_AMOUNT_KEYS.has(key)) {
        if(!value) return;
        return formatCurrency(Number(value));
    }
    if (APPLICATION_DETAILS_DATE_KEYS.has(key)) {
        if(!value) return;
        return formatUTCDateTime(value, false, true);
    }
    if (APPLICATION_DETAILS_DATE_ONLY_KEYS.has(key)) {
        if(!value) return;
        return formatUTCDate({dateString: value, addZ: false, dateMonthYear: true});
    }
    return value;
}

export const mapApplicationDetails = (applicationDetails: Record<string, any>) => {
    const result: Record<string, ApplicationDisplayItem[]> = {
        agent: [],
        summary: [],
        pivot: [],
        applicant: [],
        location: [],
        quote: [],
        payment: [],
        verification: [],
        others: [],
    };

    for (const key of APPLICATION_DETAILS_ORDERED_KEYS) {
        const combinedValue = getCombinedFieldValue(key, applicationDetails);
        const rawValue = combinedValue ?? applicationDetails[key];
        if (rawValue === undefined || (!(key in applicationDetails) && combinedValue === undefined)) continue;
        const formattedValue = formatValues(key, rawValue);
        const category = APPLICATION_DETAILS_KEY_TO_CATEGORY?.[key];
        if (category === "pivot" && (!formattedValue)) continue;
        const label = APPLICATION_DETAILS_LABEL_MAP?.[key];
        const shouldAddPivotTimestamp = category === "pivot" && PIVOT_TIME_STAMP_AVAILABLE_KEYS.has(key);
        let pivotTimeStamp: string | undefined;

        if (shouldAddPivotTimestamp) {
            const pivotCreatedOn = key === PIVOT_SOURCE_FROM
                ? applicationDetails.pivotSourceCreatedOn
                : applicationDetails.pivotTargetCreatedOn;
            pivotTimeStamp = pivotCreatedOn ? formatUTCDateTime(pivotCreatedOn, false, true) : undefined;
        }

        result[category]?.push({
            key,
            label: label ?? GetFormatTitle(capitalizeFirstLetter(key)),
            value: formattedValue,
            ...(shouldAddPivotTimestamp && { timeStamp: pivotTimeStamp }),
        });
    }

    for (const key of Object.keys(applicationDetails)) {
        if (key in APPLICATION_DETAILS_LABEL_MAP || EXCLUDED_KEYS.has(key)) continue;
        const value = applicationDetails[key];
        result.others?.push({
            key,
            label: GetFormatTitle(key),
            value: formatValues(key, value),
        });
    }

    return result;
}